import {
  IHourlySales,
  IMeta,
  IOverviewBenchmark,
  IOverviewByChannel,
  IOverviewByType,
  ISalesByItem,
  IWeeklySales,
  IBranchOverView,
} from 'src/common/interfaces/index.js'
import businessClient from 'src/services/clients/business'

const IOverviewBenchmarkResponse = { meta: IMeta, data: { object: IOverviewBenchmark } }
const IOverviewByChannelResponse = { meta: IMeta, data: { object: [IOverviewByChannel] } }
const IOverviewByCTypeResponse = { meta: IMeta, data: { object: [IOverviewByType] } }
const IHourlySalesResponse = { meta: IMeta, data: { list: [IHourlySales] } }
const IWeeklySalesResponse = { meta: IMeta, data: { list: [IWeeklySales] } }
const ISalesByItemResponse = { meta: IMeta, data: { list: [ISalesByItem], total_amount: 605, total_item: 223 } }

export const report = {
  /**
   * @param {{store_ids: number[]; from_date: string; to_date: string}} filter
   * @returns {Promise<IOverviewBenchmarkResponse>}
   */
  overviewBenchmark(filter, signal) {
    return businessClient().post('report/sales/overview/benchmark', { filter }, { signal })
  },

  /**
   * @param {{store_ids: number[]; from_date: string; to_date: string}} filter
   * @returns {Promise<IOverviewByChannelResponse>}
   */
  overviewByChannel(filter, signal) {
    return businessClient().post('report/sales/overview/by-channels', { filter }, { signal })
  },

  /**
   * @param {{store_ids: number[]; from_date: string; to_date: string}} filter
   * @returns {Promise<IOverviewByCTypeResponse>}
   */
  overviewByType(filter, signal) {
    return businessClient().post('report/sales/overview/by-sales-type', { filter }, { signal })
  },

  /**
   * @param {{store_ids: number[]; partner_ids: number[]; from_date: string; to_date: string}} filter
   * @returns {Promise<IHourlySalesResponse>}
   */
  hourlySales(filter, signal) {
    return businessClient().post('report/sales/hourly', { filter }, { signal })
  },

  /**
   * @param {{store_ids: number[]; partner_ids: number[]; from_date: string; to_date: string}} filter
   * @returns {Promise<IHourlySalesResponse>}
   */
  kitchenEfficiency(filter, signal) {
    return businessClient().post('report/kds/efficiency', { filter }, { signal })
  },

  /**
   * @param {{store_ids: number[]; partner_ids: number[]; from_date: string; to_date: string}} filter
   * @returns {Promise<IWeeklySalesResponse>}
   */
  weeklySales(filter, signal) {
    return businessClient().post('report/sales/weekly', { filter }, { signal })
  },

  /**
   * @param {{store_ids: number[]; from_date: string; to_date: string; limit: number}} filter
   * @return {Promise<ISalesByItemResponse>}
   */
  salesByItem(filter, signal) {
    return businessClient().post('report/sales/by-items', { filter }, { signal })
  },

  /**
   * @param {{store_ids: number[]; from_date: string; to_date: string; limit: number}} filter
   * @return {Promise<IBranchOverView>}
   */
  salesByBranch(filter, signal) {
    return businessClient().post('report/sales/overview/by-store', { filter }, { signal })
  },
}
